// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world


$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")
 
	// Click "Preview" to run your code
});

export function radioGroup1_click_1(event) {
	
	if ($w("#radioGroup1").value == "Частное лицо") { 
		$w("#input8").collapse();
		 
	} 
	
	if ($w("#radioGroup1").value == "Компания") { 
		
		$w("#input8").expand();
	} 
	 
}   


import wixData from 'wix-data';
let toInsert;
let imgFile;
let docFile;
  export function uploadButton1_change(event) {
  if($w("#uploadButton1").value.length > 0) { 
    $w("#uploadButton1").startUpload()
      .then( (uploadedFile) => { 
        imgFile = uploadedFile.url; 
        let fullLink = "https://static.wixstatic.com/media/" + uploadedFile.url.split("/")[3];
        $w("#input10").value = fullLink;   
 
            toInsert = { 
                "копияВашеИмя2":    uploadedFile.url,
                "photoform":    imgFile
              };  
      })
      .catch( (uploadError) => {
        console.log("Ошибка загрузки файла: " + uploadError.errorCode);
        console.log(uploadError.errorDescription);
      });
  } 
  else { 
        console.log("Выбирите файл");
  }
}
  
  
  export function uploadButton2_change(event) {
  if($w("#uploadButton2").value.length > 0) { 
    $w("#uploadButton2").startUpload()
      .then( (uploadedFile) => {  
        docFile = uploadedFile.url; 
        const convertRegex = new RegExp(/wix:document:\/\/v1\/([^\/]+)\/(.*)$/);
        const matches = docFile.match(convertRegex);
        let documentUrl = "";
        documentUrl = `docs.wixstatic.com/ugd/${matches[1]}?dn=${matches[2]}`;
        $w("#input9").value = documentUrl;  
            toInsert = { 
                "documentupload":    docFile
              };  
      })
      .catch( (uploadError) => { 
        console.log("Ошибка загрузки файла: " + uploadError.errorCode);
        console.log(uploadError.errorDescription);
      });
  } 
  else {
        console.log("Выбирите файл");
  } 
}
 
 